import SearchAllSitesContainer from 'components/SearchAllSites/SearchAllSitesContainer'

export default {
  Container: SearchAllSitesContainer,
}
